import { uiStore } from "@/store/store-accessor";

export function requestExitFromBuilder(): boolean {
  const confirmation = uiStore.closingConfirmations.builder;
  if (confirmation && !confirmation.chosenOption) {
    uiStore.showClosingConfirmation("builder");
    return false;
  }

  return true;
}
